<template>
    <customModal :containermd="true" @closeModal="$emit('closeModal')">

        <template #title>
             {{ $t("navigations.runKri") }}
        </template>

        <template #body>
            <div class="row">

                <div class="col-md-12 mb-3">
                    <label class="form-label">                    
                    {{ $t("navigations.risk indicator") }}
                    <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>
                    <select class="form-control" v-model="form.riskName" @change="clearError('riskName')">
                        <option value="">Select</option>
                        <option v-for="threshold in thresholdList" :key="threshold.riskIndicatorId"
                            :value="threshold.riskName">
                            {{ threshold.riskName }}
                        </option>
                    </select>
                    <small class="errorClass" v-if="errors.riskName">
                        {{ errors.riskName }}
                    </small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.data scope") }}
                    <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>
                    <select class="form-control" v-model="form.dataScope" @change="clearError('dataScope')">
                        <option value="">Select</option>
                        <option value="Study">Study</option>
                        <option value="Site">Site</option>
                    </select>
                    <small class="errorClass" v-if="errors.dataScope">
                        {{ errors.dataScope }}
                    </small>
                </div>

                <div class="col-md-6 mb-3" v-if="form.dataScope === 'Site'">
                    <label class="form-label">
                        {{ $t("navigations.site code") }}
                    <sup><i class="fa fa-asterisk required"></i></sup> 
                    </label>
                    <select class="form-control" v-model="selectedSite" @change="clearError('site')">
                        <option value="">Select</option>
                        <option v-for="site in sites" :key="site.siteID" :value="site">
                            {{ site.siteCode }}
                        </option>

                    </select>
                    <small class="errorClass" v-if="errors.site">
                            {{ errors.site }}
                        </small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.version") }}
                    </label>
                    <input type="text" class="form-control" v-model="form.version" />
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.from date") }}
                    </label>
                    <input type="date" class="form-control" v-model="form.fromDate" @change="clearError('fromDate')" />
                    <small class="errorClass" v-if="errors.fromDate">
                            {{ errors.fromDate }}
                        </small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.to date") }}
                    </label>
                    <input type="date" class="form-control" v-model="form.toDate" @change="clearError('toDate')" />
                    <small class="errorClass" v-if="errors.toDate">
                            {{ errors.toDate }}
                        </small>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.operator") }}
                    </label>
                    <select class="form-control" v-model="form.operator">
                        <option :value="0">Equals</option>
                        <option :value="1">Greater Than</option>
                        <option :value="2">Greater Than Or Equal</option>
                        <option :value="3">Less Than</option>
                        <option :value="4">Less Than Or Equal</option>

                    </select>
                </div>

                <div class="col-md-6 mb-3">
                    <label class="form-label">
                        {{ $t("navigations.compare value") }}
                    </label>
                    <input type="text" class="form-control" v-model="form.compareValue" />
                </div>

                <div class="col-12 text-end mt-3">
                    <button class="save_btn px-4 py-1" @click="runKri">
                        {{ $t("navigations.runKri") }}</button>
                </div>

            </div>

        </template>

    </customModal>
</template>

<script src="./RunKRIModal.js"></script>

<style scoped>
.modal-scroll-body {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
}

.save_btn {
    background-color: #1ab394;
    border: none;
    color: #fff;
    border-radius: 4px;
}
</style>
